import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B0F19]/95 backdrop-blur-md border-b border-white/10 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/1b690fcb-e208-48ed-96d2-9d63ebbac54c.png"
            alt="NegoIA Perú Logo"
            className="h-9 md:h-11 w-auto object-contain"
          />
        </div>

        <div className="hidden md:flex items-center gap-8">
          {["Características", "Testimonios", "FAQ", "Precios"].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="text-white/70 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item}
            </a>
          ))}
        </div>

        <a
          href="#cta"
          className="hidden md:inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-400 hover:from-orange-400 hover:to-orange-300 text-white font-bold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-orange-500/30 whitespace-nowrap cursor-pointer"
        >
          Acceder Ahora
          <i className="ri-arrow-right-line"></i>
        </a>

        <button className="md:hidden w-9 h-9 flex items-center justify-center text-white/80">
          <i className="ri-menu-3-line text-xl"></i>
        </button>
      </div>
    </nav>
  );
}
